"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
Object.defineProperty(exports, "__esModule", { value: true });
exports.AppStatusServiceServer = exports.AppStatusServiceDispatcher = exports.AppStatusServiceClient = void 0;
var LinkedServicesResponse_1 = require("./LinkedServicesResponse");
var TimeResponse_1 = require("./TimeResponse");
var StatusResponse_1 = require("./StatusResponse");
var InStatus = (function () {
    function InStatus(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
    }
    InStatus.prototype.serialize = function () {
        return {};
    };
    return InStatus;
}());
var InLinked = (function () {
    function InLinked(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
    }
    InLinked.prototype.serialize = function () {
        return {};
    };
    return InLinked;
}());
var InTime = (function () {
    function InTime(data) {
        if (data === void 0) { data = undefined; }
        if (typeof data === 'undefined' || data === null) {
            return;
        }
    }
    InTime.prototype.serialize = function () {
        return {};
    };
    return InTime;
}());
var AppStatusServiceClient = (function () {
    function AppStatusServiceClient(transport) {
        this._transport = transport;
    }
    AppStatusServiceClient.prototype.getPackageName = function () { return AppStatusServiceClient.PackageName; };
    AppStatusServiceClient.prototype.getClassName = function () { return AppStatusServiceClient.ClassName; };
    AppStatusServiceClient.prototype.getFullClassName = function () { return AppStatusServiceClient.FullClassName; };
    AppStatusServiceClient.prototype.send = function (method, data, inputType, outputType) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this._transport.send(AppStatusServiceClient.ClassName, method, data)
                .then(function (data) {
                try {
                    var output = new outputType(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AppStatusServiceClient.prototype.status = function () {
        var _this = this;
        var __data = new InStatus();
        return new Promise(function (resolve, reject) {
            _this._transport.send(AppStatusServiceClient.ClassName, 'status', __data)
                .then(function (data) {
                try {
                    var output = new StatusResponse_1.StatusResponse(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AppStatusServiceClient.prototype.linked = function () {
        var _this = this;
        var __data = new InLinked();
        return new Promise(function (resolve, reject) {
            _this._transport.send(AppStatusServiceClient.ClassName, 'linked', __data)
                .then(function (data) {
                try {
                    var output = new LinkedServicesResponse_1.LinkedServicesResponse(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AppStatusServiceClient.prototype.time = function () {
        var _this = this;
        var __data = new InTime();
        return new Promise(function (resolve, reject) {
            _this._transport.send(AppStatusServiceClient.ClassName, 'time', __data)
                .then(function (data) {
                try {
                    var output = new TimeResponse_1.TimeResponse(data);
                    resolve(output);
                }
                catch (err) {
                    reject(err);
                }
            })
                .catch(function (err) {
                reject(err);
            });
        });
    };
    AppStatusServiceClient.PackageName = 'net.playq.appstatus';
    AppStatusServiceClient.ClassName = 'AppStatusService';
    AppStatusServiceClient.FullClassName = 'net.playq.appstatus.AppStatusService';
    return AppStatusServiceClient;
}());
exports.AppStatusServiceClient = AppStatusServiceClient;
var AppStatusServiceDispatcher = (function () {
    function AppStatusServiceDispatcher(marshaller, server) {
        this.marshaller = marshaller;
        this.server = server;
    }
    AppStatusServiceDispatcher.prototype.getSupportedService = function () {
        return 'AppStatusService';
    };
    AppStatusServiceDispatcher.prototype.getSupportedMethods = function () {
        return AppStatusServiceDispatcher.methods;
    };
    AppStatusServiceDispatcher.prototype.dispatch = function (context, method, data) {
        var _this = this;
        switch (method) {
            case "status": {
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.status(context)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(res);
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "linked": {
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.linked(context)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(res);
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            case "time": {
                return new Promise(function (resolve, reject) {
                    try {
                        _this.server.time(context)
                            .then(function (res) {
                            var serialized = _this.marshaller.Marshal(res);
                            resolve(serialized);
                        })
                            .catch(function (err) {
                            reject(err);
                        });
                    }
                    catch (err) {
                        reject(err);
                    }
                });
            }
            default:
                throw new Error("Method ".concat(method, " is not supported by AppStatusServiceDispatcher."));
        }
    };
    AppStatusServiceDispatcher.methods = [
        "status",
        "linked",
        "time"
    ];
    return AppStatusServiceDispatcher;
}());
exports.AppStatusServiceDispatcher = AppStatusServiceDispatcher;
var AppStatusServiceServer = (function (_super) {
    __extends(AppStatusServiceServer, _super);
    function AppStatusServiceServer(marshaller) {
        var _this = _super.call(this, marshaller, null) || this;
        _this.server = _this;
        return _this;
    }
    AppStatusServiceServer.prototype.status = function (context) {
        throw new Error('Not implemented.');
    };
    AppStatusServiceServer.prototype.linked = function (context) {
        throw new Error('Not implemented.');
    };
    AppStatusServiceServer.prototype.time = function (context) {
        throw new Error('Not implemented.');
    };
    return AppStatusServiceServer;
}(AppStatusServiceDispatcher));
exports.AppStatusServiceServer = AppStatusServiceServer;
//# sourceMappingURL=AppStatusService.js.map